module.exports = __webpack_public_path__ + "img/bg-maintenance.6438a084.svg";